var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A65E5",
    d: "M24,19.894c0,2.209-1.791,4-4,4H4.029c-2.209,0-4-1.791-4-4V4.083c0-2.209,1.791-4,4-4H20 c2.209,0,4,1.791,4,4V19.894z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12.207,6.04c0.579,0.194,0.779,0.604,0.778,1.202c-0.01,6.611-0.006,0.454-0.006,7.064 c0,0.096,0,0.19,0,0.345c0.1-0.097,0.167-0.158,0.23-0.222c1.038-1.042,2.075-2.083,3.111-3.125 c0.281-0.283,0.617-0.376,0.993-0.264c0.349,0.103,0.572,0.35,0.654,0.707c0.085,0.369-0.04,0.675-0.303,0.939 c-1.162,1.167-2.322,2.335-3.483,3.502c-0.431,0.434-0.852,0.876-1.297,1.293c-0.2,0.188-0.45,0.321-0.677,0.479 c-0.129,0-0.257,0-0.386,0c-0.228-0.158-0.484-0.287-0.677-0.479c-1.594-1.586-3.177-3.184-4.763-4.779 c-0.423-0.426-0.462-0.979-0.105-1.38c0.381-0.428,1.006-0.441,1.431-0.017c1.04,1.039,2.076,2.082,3.111,3.125 c0.061,0.063,0.104,0.141,0.157,0.211c0.025-0.012,0.05-0.024,0.075-0.036c0-0.092,0-0.183,0-0.274c0-6.618,0.004-0.469-0.006-7.087 c-0.001-0.598,0.199-1.008,0.778-1.203C11.949,6.04,12.078,6.04,12.207,6.04z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.01b6351dfb73b28c8f9c5f76251579ce.svg";
export { ForwardRef as ReactComponent };